import React, { createContext, useContext, useState, useEffect } from 'react';
import axios from 'axios';

const SiteSettingsContext = createContext(null);

const API_BASE = process.env.REACT_APP_API_URL || 'http://localhost:5000';

export const SiteSettingsProvider = ({ children }) => {
  const [settings, setSettings] = useState(null);
  const [loading, setLoading]   = useState(true);

  useEffect(() => {
    axios.get(`${API_BASE}/api/admin/settings/public`)
      .then(res => setSettings(res.data))
      .catch(() => {
        // If settings endpoint fails, show all tabs by default
        setSettings(null);
      })
      .finally(() => setLoading(false));
  }, []);

  // Helper: is a specific user tab enabled?
  const isUserTabEnabled = tabKey => {
    if (!settings?.userTabs?.[tabKey]) return true; // default: show
    return settings.userTabs[tabKey].enabled !== false;
  };

  // Helper: get user tab label (allows admin to rename tabs)
  const getUserTabLabel = (tabKey, fallback) => {
    return settings?.userTabs?.[tabKey]?.label || fallback;
  };

  // Helper: is a provider tab enabled?
  const isProviderTabEnabled = tabKey => {
    if (!settings?.providerTabs?.[tabKey]) return true;
    return settings.providerTabs[tabKey].enabled !== false;
  };

  const getProviderTabLabel = (tabKey, fallback) => {
    return settings?.providerTabs?.[tabKey]?.label || fallback;
  };

  // Helper: is a public profile section enabled?
  const isPublicSectionEnabled = sectionKey => {
    if (!settings?.publicProfileSections?.[sectionKey]) return true;
    return settings.publicProfileSections[sectionKey].enabled !== false;
  };

  return (
    <SiteSettingsContext.Provider value={{
      settings, loading,
      isUserTabEnabled, getUserTabLabel,
      isProviderTabEnabled, getProviderTabLabel,
      isPublicSectionEnabled
    }}>
      {children}
    </SiteSettingsContext.Provider>
  );
};

export const useSiteSettings = () => {
  const ctx = useContext(SiteSettingsContext);
  if (!ctx) throw new Error('useSiteSettings must be inside SiteSettingsProvider');
  return ctx;
};
